document.addEventListener('DOMContentLoaded', function() {
  const FREE_SHIPPING_THRESHOLD = 80;
  
  function updateBar() {
    let cartTotal = 0;
    
    if (typeof window.cart !== 'undefined' && window.cart.total_price) {
      cartTotal = window.cart.total_price / 100;
      renderBar(cartTotal);
      return;
    }
    
    fetch('/cart.js')
      .then(res => res.json())
      .then(data => {
        cartTotal = data.total_price / 100;
        renderBar(cartTotal);
      })
      .catch(err => {
        console.warn('Cart fetch failed:', err);
        document.querySelectorAll('.free-shipping-bar').forEach(bar => {
          bar.style.display = 'none';
        });
      });
  }

  function renderBar(cartTotal) {
    const bars = document.querySelectorAll('.free-shipping-bar');
    if (!bars.length) return;

    const remaining = Math.max(0, FREE_SHIPPING_THRESHOLD - cartTotal);
    const percent = Math.min(100, (cartTotal / FREE_SHIPPING_THRESHOLD) * 100);

    bars.forEach(bar => {
      const amountEl = bar.querySelector('.free-shipping-bar__amount');
      const fillEl = bar.querySelector('.free-shipping-bar__fill');
      const iconEl = bar.querySelector('.free-shipping-bar__icon');
      const textEl = bar.querySelector('.free-shipping-bar__text');
      
      if (!amountEl || !fillEl || !textEl) return;
      
      if (cartTotal >= FREE_SHIPPING_THRESHOLD) {
        textEl.innerHTML = '<span class="free-shipping-bar__amount">Kostenloser Versand!</span>';
        bar.classList.add('free-shipping-bar--completed');
        if (iconEl) {
          iconEl.style.filter = 'none';
          iconEl.style.transform = 'scale(1.1)';
        }
      } else {
        amountEl.textContent = remaining.toFixed(2).replace('.', ',');
        textEl.innerHTML = `<span class="free-shipping-bar__amount">Noch €${remaining.toFixed(2).replace('.', ',')}</span><span class="free-shipping-bar__goal"> bis zum kostenlosen Versand</span>`;
        bar.classList.remove('free-shipping-bar--completed');
        if (iconEl) {
          iconEl.style.filter = 'grayscale(100%) brightness(0.8)';
          iconEl.style.transform = 'scale(1)';
        }
      }

      fillEl.style.width = percent + '%';
      
      bar.style.display = cartTotal > 0 ? 'block' : 'none';
    });
  }
  
  updateBar();


  document.addEventListener('cart-update', updateBar);
  document.addEventListener('cart-add', updateBar);
  document.addEventListener('cart-remove', updateBar);
  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.dataset.sectionId === 'header') {
      setTimeout(updateBar, 100);
    }
  });
  

  setInterval(updateBar, 2000);
});